import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "meeting-history-notes"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "ai-notes-recap"
}
const _hoisted_4 = { class: "ai-notes-state" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.linksOnly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r, i) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: r.jobId,
            to: '/ai-review/'+r.jobId,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode("View notes & transcript" + _toDisplayString(_ctx.rows.length > 1 ? ` (${i + 1})` : ''), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        (!_ctx.rows.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.unavailable ? 'Notes unavailable — try again later' : 'No recorded notes'), 1))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.rows.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", null, [
            _createTextVNode("Meeting notes "),
            _createElementVNode("span", { class: "ai-tag" }, "AI")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r) => {
            return (_openBlock(), _createElementBlock("article", {
              key: r.jobId
            }, [
              (r.notes)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(r.status === 'accepted' ? 'Accepted notes' : 'Draft — awaiting review'), 1),
                    _createElementVNode("p", null, _toDisplayString(r.notes.summary), 1),
                    (r.notes.decisions.length)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_5, "Decisions"))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.notes.decisions, (d, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(d), 1))
                      }), 128))
                    ]),
                    (r.notes.actionItems.length)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_6, "Action items"))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.notes.actionItems, (a, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, [
                          _createTextVNode(_toDisplayString(a.text), 1),
                          (a.assigneeName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " — " + _toDisplayString(a.assigneeName), 1))
                            : _createCommentVNode("", true),
                          (a.due)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(a.due), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_router_link, {
                      to: '/ai-review/'+r.jobId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(r.status === 'accepted' ? 'View notes & transcript' : 'Review draft'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (r.hasRecording)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 2,
                          playsinline: "",
                          controls: "",
                          preload: "none",
                          src: (_ctx.$store.state.apiUrl || '') + '/api/ai/meeting-notes/'+r.jobId+'/audio'
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}